var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"range",style:({ left: ((_vm.percent(0)) + "%"), right: ((100 - _vm.percent(1)) + "%") })})])}
var staticRenderFns = []

export { render, staticRenderFns }